import React from "react";
import { useGlobal } from "reactn";

import { Section } from "@jsluna/section";
import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import missionConfig from "missionConfig";

import useCookies from "hooks/useCookies";
import { accountRecoveryUserData } from "constants/mfaAndOtp";

import AutoLogInButton from "../Login/AutoLogInButton";
import ResetPasswordNotificationMessage from "./ResetPasswordNotificationMessage";

const ResetPasswordSuccess = ({ viaAccountRecovery = false }) => {
  const [userData] = useGlobal(accountRecoveryUserData);
  const { email } = useCookies();
  const { password } = userData || {};

  const { showBackToLoginButton } = missionConfig;

  return (
    <>
      <div className="c-hero c-hero--center">
        <h1>New password saved</h1>
      </div>

      <ResetPasswordNotificationMessage />

      <Section>
        <Notification type={NotificationStatuses.SUCCESS_TYPE}>
          You successfully updated your password.
        </Notification>
      </Section>

      <Section>
        {viaAccountRecovery && (
          <p className="ln-u-margin-bottom*3">
            Remember to update your email address after you login.
          </p>
        )}
        {showBackToLoginButton && (
          <AutoLogInButton username={email} password={password} />
        )}
      </Section>
    </>
  );
};

export default ResetPasswordSuccess;
